module.exports = __webpack_public_path__ + "static/img/14.d5a9e61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/14.jpg
// module id = moX0
// module chunks = 0